import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {AbstractControl} from "@angular/forms";
import { KeyValuePipe } from "@angular/common";

@Component({
    selector: 'app-error-display',
    imports: [
    KeyValuePipe
],
    templateUrl: './error-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error-display.component.scss'
})
export class ErrorDisplayComponent {
  @Input() control!: AbstractControl | null;
  @Input() messages: Record<string, string> = {};

  /**
   * Get all messages with default messages, those default message are for now defined in the method,
   * but can be moved to a separate file or a service in the future
   *
   * @returns Record<string, string>
   */
  public getAllMessages(): Record<string, string> {
    const defaultMessage: Record<string, string> = {
      required: 'Dit is een verplicht veld',
      email: 'Dit is geen geldig e-mailadres',
      minlength: 'Dit veld bevat niet voldoende tekens',
      containsNumber: 'Dit veld moet minimaal 1 nummer bevatten',
      containsUppercase: 'Dit veld moet minimaal 1 hoofdletter bevatten',
      containsSpecialCharacter: 'Dit veld moet minimaal 1 speciaal teken bevatten',
      matches: 'Dit veld komt niet overeen met het andere veld',
      'The password is incorrect.': 'Het wachtwoord is onjuist',
      'Something wrong with email.': 'Het is niet gelukt om je e-mailadres te wijzigen, neem contact op met de klantenservice.',
      "The data.password field must be at least 8 characters.": "Het wachtwoord moet minimaal 8 tekens bevatten",
      "The data.password field must contain at least one uppercase and one lowercase letter.": "Het wachtwoord moet minimaal 1 hoofdletter en 1 kleine letter bevatten",
      "The data.password field must contain at least one symbol.": "Het wachtwoord moet minimaal 1 speciaal teken bevatten",
      "The data.password field must contain at least one number.": "Het wachtwoord moet minimaal 1 nummer bevatten",
    };

    //merge default messages with custom messages
    return Object.assign(defaultMessage, this.messages);
  }
}
